
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

jQuery(($) => {
    $(".gallery--slider").each(function() {
        const $this = $(this);
        const unique_slider_id = $this.data("id"); // Get the unique ID for the current slider

        if ($this.length && unique_slider_id) {
            // Initialize Swiper for each slider
            new Swiper(`.gallery--slider-${unique_slider_id}`, {
                modules: [Navigation],
                spaceBetween: 30,
                speed: 750,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: `.gallery--slider-button-next-${unique_slider_id}`,
                    prevEl: `.gallery--slider-button-prev-${unique_slider_id}`,
                },
                breakpoints: {
                    320: {
                      spaceBetween: 20
                    },
                    640: {
                      spaceBetween: 25
                    },
                    1024: {
                        spaceBetween: 30,
                    }
                }
            });
        }
    });
});
